import { useState, useEffect } from 'react';
import { getImageUrl } from '@/shared/utils/imageUtils';
import { logger } from '@/shared/utils/logger';

/**
 * Hook simple pour récupérer l'URL d'une image
 * Gère automatiquement les URLs gs://, http/https et les chemins publics
 */
export const useImageUrl = (
  url: string | null | undefined,
  fallback?: string
): string | null => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!url) {
      getImageUrl(null, fallback).then(setImageUrl);
      return;
    }

    getImageUrl(url, fallback)
      .then(setImageUrl)
      .catch((error) => {
        logger.error('Erreur lors de la récupération de l\'image:', error);
        // En cas d'erreur, utiliser le fallback
        getImageUrl(null, fallback).then(setImageUrl);
      });
  }, [url, fallback]);

  return imageUrl;
};

